import { siteRoutes } from "utils/helpers/enums/routes";
import { ROLES } from "utils/helpers/enums/roles.enum";

export const roleBasedRoutes = {
  [ROLES.HOST]: [
    siteRoutes.home,
    siteRoutes.experiences,
    siteRoutes.experienceDetail,
    siteRoutes.attendess,
    siteRoutes.createExperience,
    siteRoutes.communities,
    siteRoutes.hostProfile,
    siteRoutes.editProfile,
    // siteRoutes.myExperience,
    siteRoutes.subscription,
    siteRoutes.resourceLibrary,
    siteRoutes.myBadges,
    siteRoutes.myRepresentatives,
    siteRoutes.myRating,
    siteRoutes.reviewsCups,
    siteRoutes.generalSettings,
    siteRoutes.managePayments,
    siteRoutes.createBadges,
    siteRoutes.createBadge,
    siteRoutes.hostEventBadges,
    siteRoutes.myCancelledTickets,
    siteRoutes.hostMobileSubscription,
  ],
  [ROLES.ATTENDEE]: [
    siteRoutes.attendeeHome,
    siteRoutes.parentGuardianDetails,
    siteRoutes.familyInformation,
    siteRoutes.declarationForm,
    siteRoutes.attendeeExperiences,
    siteRoutes.editAttendeeProfile,
    siteRoutes.generalSettingsAttendee,
    siteRoutes.attendeeCommunities,
    siteRoutes.familyMembers,
    siteRoutes.experiencesDetailAttendee,
    siteRoutes.ratings,
    siteRoutes.signedUpExperienceAttendee,
    siteRoutes.attendeeJoining,
    siteRoutes.attendeeJoinAndPay,
    siteRoutes.attendeeHostProfileDetail,
    siteRoutes.familyDetail,
    siteRoutes.attendeePasses,
    siteRoutes.attendeeResourceLibrary,
    siteRoutes.attendeeFavoriteHosts,
    siteRoutes.reviewsCups,
    siteRoutes.familyDetailAssessment,
    siteRoutes.assessmentLearningSkills,
  ],
  [ROLES.CHILD]: [
    siteRoutes.minorHome,
    siteRoutes.minorExperiences,
    siteRoutes.minorExperienceDetail,
    siteRoutes.minorDigitalPassport,
    siteRoutes.minorFavoriteHost,
    siteRoutes.minorGeneralSettings,
    siteRoutes.minorEditProfile,
    siteRoutes.minorExperiencesDetail,
    siteRoutes.minorRatings,
    siteRoutes.minorTicket,
    siteRoutes.minorProfileDetailHost,
    siteRoutes.minorEventRatings,
  ],
  [ROLES.AMBASSADOR]: [
    siteRoutes.ambassadorHome,
    siteRoutes.ambassadorProfile,
    siteRoutes.ambassadorWelcome,
    siteRoutes.ambassadorGeneralSettings,
    siteRoutes.ambassadorExperiences,
    siteRoutes.ambassadorExperiencesDetail,
    siteRoutes.ambassadorResourceLibrary,
    siteRoutes.ambassadorRedeemPrizePoints,
    siteRoutes.ambassadorFamilyprofile,
    siteRoutes.ambassadorEditProfile,
    siteRoutes.ambassadorMyBadges,
    siteRoutes.ambassadorWallet,
    siteRoutes.ambassadorCommunities,
    siteRoutes.ambassadorfollowExperiences,
    siteRoutes.ambassadorJoinEvents,
    siteRoutes.ambassadorAdminExperienceDetail,
  ],
  [ROLES.RSVP]: [
    siteRoutes.rsvpHome,
    siteRoutes.rsvpExperiences,
    siteRoutes.rsvpEditProfile,
    siteRoutes.rsvpExperiencesDetail,
    siteRoutes.rsvpHostProfileDetail,
    siteRoutes.rsvpMyBadges,
    siteRoutes.rsvpGeneralSettings,
    siteRoutes.rsvpAttendess,
    siteRoutes.rsvpRatings,
    siteRoutes.rsvpRating,
    siteRoutes.rsvpViewRatings,
    siteRoutes.rsvpCommunities,
  ],
};

export const authAccessibleRoutes = [
  siteRoutes.registerInfo,
  siteRoutes.ambassadorRole,
];
